import React from 'react';
import './Spinner.css';

const Spinner = () => {
    return (
        <div className={'Spinner'}>
            <div className="Spinner__loader"></div>
        </div>
    );
};

export default Spinner;